"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCardPrices = instanceOfCardPrices;
exports.CardPricesFromJSON = CardPricesFromJSON;
exports.CardPricesFromJSONTyped = CardPricesFromJSONTyped;
exports.CardPricesToJSON = CardPricesToJSON;
exports.CardPricesToJSONTyped = CardPricesToJSONTyped;
/**
 * Check if a given object implements the CardPrices interface.
 */
function instanceOfCardPrices(value) {
    if (!('tcgplayer' in value) || value['tcgplayer'] === undefined)
        return false;
    if (!('cardkingdom' in value) || value['cardkingdom'] === undefined)
        return false;
    if (!('cardmarket' in value) || value['cardmarket'] === undefined)
        return false;
    return true;
}
function CardPricesFromJSON(json) {
    return CardPricesFromJSONTyped(json, false);
}
function CardPricesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tcgplayer': json['tcgplayer'],
        'cardkingdom': json['cardkingdom'],
        'cardmarket': json['cardmarket'],
    };
}
function CardPricesToJSON(json) {
    return CardPricesToJSONTyped(json, false);
}
function CardPricesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tcgplayer': value['tcgplayer'],
        'cardkingdom': value['cardkingdom'],
        'cardmarket': value['cardmarket'],
    };
}
//# sourceMappingURL=cardPrices.js.map